<template>
    <div class="page">
        <v-container class="py-3 py-lg-6">
            <v-card v-if="pageData" :class="{'py-2 px-3 bordered': pcOnly}" flat>
                <v-card-title :class="{'px-2': phoneOnly}">Privacy Policy</v-card-title>
                <v-card-text :class="{'px-2': phoneOnly}">
                    <p class="strong-text--text medium-text" style="white-space: pre-line; line-height: 2" :class="{'ltr-dir text-left': detectDir(pageData.text) === 'ltr',}">
                        {{pageData.text}}
                    </p>
                </v-card-text>
            </v-card>
        </v-container>

        <slot v-if="!isAuthed" name="footer" />
    </div>
</template>
<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    components: {
        
    },
    data(){
        return {
            loading: false,
            pageData: null,
        }
    },
    computed: {
        ...GlobalComputed,
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
    },
    methods: {
        ...GlobalMethods,

        detectDir(text){
            const rtlChar = /[\u0590-\u083F]|[\u08A0-\u08FF]|[\uFB1D-\uFDFF]|[\uFE70-\uFEFF]/mg;
            if (text){
                if (rtlChar.test(text.charAt(0))){
                    // is rtl 
                    return 'rtl';
                }else{
                    return 'ltr';
                }
            }
            return 'rtl';
        },
        getPageData(){
            if (!this.loading){
                this.loading = true;
                const url = '/privacy';
                this.$store.dispatch('fastGetAction', {url}).then(response=>{
                    this.loading = false;
                    this.pageData = response.data;

                }).catch(()=>{
                    this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    this.loading = false;
                });
            }
        },
    },
    mounted(){
        if (!this.pageData){
            this.getPageData();
        }
    }
}
</script>